import * as React from 'react';
import * as $ from 'jquery';
import * as _ from 'underscore';
import * as moment from 'moment';

import RoomCell from './RoomCell';

import RoomRepository from '../../repositories/RoomRepository';
import Room from '../../models/Room';

import './floor-plan.less';

interface P {
    from: moment.Moment;
    thru: moment.Moment;
    checked: Room[];
    onAdd: (room: Room) => void;
    onRemove: (room: Room) => void;
}

interface S {
    rooms: Room[];
}

export default class FloorPlan extends React.Component<P, S> {

    static contextTypes: React.ValidationMap<any> = {
        room_repository: React.PropTypes.object
    }

    context: {
        room_repository: RoomRepository;
    };

    constructor( props: P, context: any ) {
        super( props, context );

        this.state = { rooms: undefined };
    }

    componentDidMount() {
        this.list( this.props.from, this.props.thru );
    }

    componentWillReceiveProps( nextProps: P ) {
        if ( !nextProps.from.isSame( this.props.from, 'day' ) ||
             !nextProps.thru.isSame( this.props.thru, 'day' ) )
            this.list( nextProps.from, nextProps.thru );
    }

    private list( from: moment.Moment, thru: moment.Moment ) {
        $.when( this.context.room_repository.findAll(),
                this.context.room_repository.findAvailable(from, thru) ).
          done((all: Room[], avail: Room[]) =>
              this.setState({ rooms: _.map(all, room => _.findWhere(avail, { name: room.name }) || room) }) );
    }

    render() {
        if ( !this.state.rooms )
            return null;

        return (
            <div className="clear floor-plan component">
              <h3>&uarr;Beach&uarr;</h3>

              <div className="clear f1">
                <h3>1F</h3>

                { _.chain(this.state.rooms).
                    where({ floor: '1f' }).
                    sortBy( 'name' ).
                    value().
                    map( r =>
                        <RoomCell key={ r.name }
                                  room={ r }
                                  checked={ _.contains( this.props.checked, r ) }
                                  onChecked={ this.props.onAdd }
                                  onCleared={ this.props.onRemove } />
                    ) }

              <div className="swimming-pool">
                Large Heated<br />
                Swimming Pool
              </div>
              <div className="left stairs"></div>
              <div className="right stairs"></div>
              <div className="lobby cell">
                <div className="name">Hotel Lobby</div>
              </div>
              <div className="laundry cell">
                <div className="name">Laundry Room</div>
              </div>
              </div>

              <div className="clear f2">
                <h3>2F</h3>

                { _.chain(this.state.rooms).
                    where({ floor: '2f' }).
                    sortBy( 'name' ).
                    value().
                    map( r =>
                        <RoomCell key={ r.name }
                                  room={ r }
                                  checked={ _.contains( this.props.checked, r ) }
                                  onChecked={ this.props.onAdd }
                                  onCleared={ this.props.onRemove } />
                    ) }
              </div>
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/booking/FloorPlan.tsx
 **/